/* global axios */
import ApiClient from './ApiClient';

class SdrAnalyticsAPI extends ApiClient {
  constructor() {
    super('sdr_analytics', { accountScoped: true });
  }

  getMetrics(params = '30d') {
    const queryParams = typeof params === 'string' ? { period: params } : params;
    return axios.get(`${this.url}`, {
      params: queryParams,
    });
  }

  getSummaryWidget() {
    return axios.get(`${this.url}/summary_widget`);
  }

  generateAiReport(params = '30d') {
    const payload = typeof params === 'string' ? { period: params } : params;
    return axios.post(`${this.url}/generate_ai_report`, payload);
  }
}

export default new SdrAnalyticsAPI();
